<template>
<div>
  <transparentheaders class="white" ref="brother"></transparentheaders>
  <div class="background">
    <div class="container">
      <div class="friend">
        <!-- 
        <audio source controls="controls" hidden src="../assets/audios/y1479.mp3" id="my_audio" type="audio/mpeg" autoplay> </audio> -->
        <div class="friend-left">
          <el-collapse v-model="activeNames">
            <el-collapse-item name="1">
              <span class="collapse-title" slot="title">圈友<el-badge class="aboutdot" is-dot v-if="aboutfriend"></el-badge></span>

              <div id="content" v-if="groupItems.length" v-for="(item, i) in groupItems" :key="i">

                <i slot="prefix" class="rel"><span class="numcare" v-for="(itema, j) in propernum" :key="j" v-if="itema.f1 && item.id == itema.f0">{{itema.f1 > 99 ? "99":itema.f1}}</span>
                  <router-link :to="{path:'/mycenter',query:{roleId:item.id}}"> <img class="headicon" :src="imgUrl + item.personPic" v-if="item.personPic" />
                    <img class="headicon" src="../assets/images/mycenterheadpicture.png" v-else /></router-link>

                </i>
                <span @click="getchatRecord_click(item.id,item.personPic)" class="nameclick">{{ item.mininame | ellipsis }}</span>
              </div>
              <div id="content_new_no" v-if="!groupItems.length">

                暂无圈友 </div>
            </el-collapse-item>
            <div class="friendlist">
              <el-collapse-item name="2">
                <span class="collapse-title1" slot="title" @click="getfriendUser">好友<el-badge class="item1" v-if="showred" is-dot></el-badge></span>

                <!-- <el-collapse-item class="collapse_down" v-for="(item, i) in groupname" :key="i">
                  <span class="collapse-title-down" slot="title">{{
                      item.name | ellipsis
                    }}</span>
                  <div id="content" class="newcontent" v-for="(item, i) in newgroupItems" :key="i">
                    <div></div>
                    <i v-if="item.icon" slot="prefix" @click="pushmycenter()"><img class="headicon" :src="item.icon" /></i><span @click="pushmycenter()">{{ item.text }}</span>

                    <i v-if="item.icon" class="el-icon-edit" @click="dialogFormVisible = true"></i>

                    <div v-if="item.icon" class="notes">
                      备注：{{ item.notes }}
                    </div>
                  </div>

                </el-collapse-item> -->
                <el-collapse v-model="activeNames">
                  <el-collapse-item class="collapse_down" v-for="(item, index) in friendItems" :key="index" :name="index">

                    <span class="collapse-title-down" slot="title">{{ index }}<span v-if="item.length" class="countnum">{{ item.length }}</span></span>

                    <div id="content_new" class="ungroup" v-if="item.length" v-for="(item1, index1) in item" :key="index1">

                      <i slot="prefix" class="rel"><span class="numcare" v-for="(itemb, j) in propernum" :key="j" v-if="itemb.f1&&item1.friendsId == itemb.f0">{{itemb.f1 > 99 ? 99 : itemb.f1}}</span>
                        <router-link :to="{path:'/mycenter',query:{roleId:item1.friendsId}}"> <img v-if="item1.friendPic" class="headicon" :src="imgUrl + item1.friendPic" />
                          <img v-else class="headicon" src="../assets/images/mycenterheadpicture.png" /></router-link>
                      </i>
                      <span class="nameclick" @click="getchatRecord_click(item1.friendsId)">{{ item1.friendMiniName | ellipsis }}</span>
                      <i class="el-icon-edit" @click="opendialog(item1.id,item1.memo,item1.groupId)

                        "></i>
                      <div class="notes">
                        备注：{{ item1.memo | ellipsisnote }}
                      </div>
                    </div>
                    <el-dialog title="好友分组" :visible.sync="dialogFormVisible" :append-to-body="true">
                      <el-dialog width="30%" title="新建分组" :visible.sync="innerVisible" append-to-body>
                        <el-form :model="form">
                          <el-form-item label="新建分组" :label-width="formLabelWidth">
                            <el-input v-model="newgroup" placeholder="请输入分组名称">
                            </el-input>
                          </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                          <el-button @click="innerVisible = false;getfriendUser();">取 消</el-button>
                          <el-button type="primary" @click="
                              newgrouplist
                            ">确 定</el-button>
                        </div>
                      </el-dialog>
                      <el-form :model="form">
                        <el-form-item label="选择分组" :label-width="formLabelWidth">
                          <el-select v-model="groupvalue" placeholder="请选择分组" @change="changegroup">
                            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            <!-- <el-option  v-for="item in regionList"
              :key="item.id"
              :label="item.name"
              :value="item.id"></el-option> -->
                          </el-select>
                          <el-button class="newgroup" type="primary" @click="
                              innerVisible = true;
                              cleargroup();
                            ">新建分组</el-button>
                        </el-form-item>

                        <el-form-item label="备注" :label-width="formLabelWidth">
                          <el-input v-model="note" autocomplete="off"></el-input>
                        </el-form-item>
                      </el-form>
                      <div slot="footer" class="dialog-footer">
                        <el-button @click="
                            dialogFormVisible = false;
                            clear();
                          ">取 消</el-button>
                        <el-button class="surebutton_group" type="primary" @click="submitgroup
                          ">确 定</el-button>
                      </div>
                    </el-dialog>
                  </el-collapse-item>
                </el-collapse>
              </el-collapse-item>
            </div>

            <el-collapse-item name="3">
              <span class="collapse-title" slot="title" @click="shownewfriend()">新朋友<el-badge :value="newnum" class="item" v-if="newnum" :max="99"></el-badge></span>
              <div id="content_new" class="friendcontent" v-for="(item, i) in newItems" :key="i" v-if="newItems.length">
                <i slot="prefix">
                  <router-link :to="{path:'/mycenter',query:{roleId:item.appuserId}}"><img v-if="item.friendPic" class="headicon" :src="imgUrl + item.friendPic" />
                    <img v-else class="headicon" src="../assets/images/mycenterheadpicture.png" /></router-link>
                </i>
                <router-link :to="{path:'/mycenter',query:{roleId:item.appuserId}}"><span class="nameclick">{{ item.friendMiniName| ellipsisnew }}</span></router-link>
                <span class="totalbutton">
                  <el-button class="agreebutton" @click="agreefriend(item.id)">同意</el-button>

                  <el-button class="refusebutton" @click="rejectfriend(item.id)">拒绝</el-button>
                </span>
              </div>
              <div v-if="!completeItems.length && !newItems.length" id="content_new_no">暂无好友申请</div>
              <div id="content_new" class="friendcontent" v-for="(item, index) in completeItems" :key="index" v-if=" completeItems.length">
                <i slot="prefix">
                  <router-link :to="{path:'/mycenter',query:{roleId:item.friendsId}}"><img v-if="item.friendPic" class="headicon" :src="imgUrl + item.friendPic" />
                    <img v-else class="headicon" src="../assets/images/mycenterheadpicture.png" /></router-link>
                </i>
                <router-link :to="{path:'/mycenter',query:{roleId:item.friendsId}}"><span class="nameclick">{{ item.friendMiniName| ellipsis }}</span></router-link>
                <span class="verify" v-if="item.friendsState === 0">等待验证</span>
                <span class="verify" v-if="item.friendsState === 1">已同意</span>
                <span class="verify" v-if="item.friendsState === 2">已拒绝</span>

                <div class="notes" v-if="item.memo">
                  备注：{{ item.memo | ellipsisnote }}
                </div>
              </div>

            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="friend-right">
          <div class="header">
            <div class="select"><span>圈子</span>
              <el-select v-model="circle" class="select_p" @change="changepropertyId">
                <el-option v-for="item in selectList1" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="select"> <span>行业</span>
              <el-select v-model="industry" class="select_industry" @change="changeindustryId" clearable>
                <el-option v-for="item in selectList2" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="select"><span>大区</span>
              <el-select v-model="region" class="select_region" @change="changeregionId" clearable>
                <el-option v-for="item in selectList3" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div>
              <el-input @keyup.enter.native="loadAll()" class="find" placeholder="关键词查询" v-model="searchvalue" @input="reset()" maxlength="50" clearable>
                <i slot="prefix"><img class="findimg" src="../assets/images/find.png" /></i>
              </el-input>

              <el-button type="primary" class="search" @click="findvalue = true;loadAll()">查询</el-button>
            </div>

          </div>
          <div class="chatnametitle" v-if="chatname">{{ chatname }}</div>
          <div class="content" ref="scrollDiv" @scroll="handleScroll($event)">

            <div class="chatcontent" v-for="(item, i) in chatItems" :key="i">
              <div class="chat-user-1" v-if="!(item.fromUserId == me)">

                <router-link :to="{path:'/mycenter',query:{roleId:item.fromUserId}}"> <img class="chat-user-1-headicon" :src="imgUrl + item.mePic" v-if="item.mePic" />
                  <img class="chat-user-1-headicon" src="../assets/images/mycenterheadpicture.png" v-else /></router-link>
                <div class="flex">
                  <div class="chatname" v-if="item.content">{{item.mininame}}
                    <span class="time">{{item.createTime.substr(0,16)}}</span>
                  </div>
                  <div v-if="item.contentType === 0">
                    <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                  </div>
                  <div class="chat-user-1-text" v-if="item.contentType === 1">
                    <span v-html="setKeyWord1(item.content)" :class="['image-container']"></span>
                  </div>
                  <div v-if="item.contentType === 2">
                    <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                  </div>
                  <div v-if="item.contentType == 3">
                    <div class="chat-user-1-text" @click="openFile(imgUrl+item.content)">文件下载</div>
                  </div>
                </div>
              </div>
              <div class="chat-user-2" v-else>

                <router-link :to="{path:'/mycenter',query:{roleId:item.fromUserId}}">

                  <img class="chat-user-2-headicon" :src="imgUrl + item.mePic" v-if="item.mePic" />
                  <img class="chat-user-2-headicon" src="../assets/images/mycenterheadpicture.png" v-else /></router-link>
                <div class="flex_2">
                  <div class="time_me_up"><span class="time_me">{{item.createTime.substr(0,16)}}</span></div>
                  <div v-if="item.contentType === 0">

                    <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>

                  </div>
                  <div class="chat-user-2-text" v-if="item.contentType === 1">
                    <span v-html="setKeyWord2(item.content)" :class="['image-container']"></span>
                  </div>
                  <div v-if="item.contentType === 2">
                    <viewer> <img class="dialogimg" :src="imgUrl + item.content" /></viewer>
                  </div>
                  <div v-if="item.contentType == 3">
                    <div class="chat-user-2-text" @click="openFile(imgUrl+item.content)">文件下载</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom" v-if="chatname">
            <div class="emopackage">
              <img class="emoimg" v-for="(item, i) in emoItems" :key="i" :src="imgUrl + item.icon" @click="sendimg(item.icon)" />
            </div>
            <div class="dialog_icon_total">
              <div>
                <img class="dialog_icon" @click="showexpression()" src="../assets//images/expression.png" />
              </div>

              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" type="file" :data="multipartFile1" :on-success="updatepicture1" accept=".tiff,.jfif,.bmp,.gif,.svg,.png,.jpeg,.svgz,.jpg,.webp,.ico,.xbm,.dib,.pjp,.apng,.tif,.pjpeg,.avif" :on-preview="handlePreview">
                <div>
                  <img class="dialog_icon" src="../assets//images/photo.png" />
                </div>
              </el-upload>
              <el-upload class="upload-demo" action="https://ringstar.xhqj71.com/jeecg-boot/sys/common/upload" :data="multipartFile2" :on-success="updatepicture2" accept=".zip,.doc,.docx,.xlsx,.xls,.txt,.ppt,.pptx,.pdf">
                <img class="dialog_icon" src="../assets/images/file.png" />
              </el-upload>

              <!-- <el-input class="textarea_submit"
                  v-model="textarea"
                  @input="onInput"
                  @keydown.native="handleKeyCode($event)"
                /> -->
            </div>

            <!-- <el-input class="textarea_submit" type="textarea" :rows="2" placeholder="请输入文字" v-model="textarea" @keydown.native="handleKeyCode($event)">
            </el-input> -->
            <quill-editor class="ql-editor" v-model="textarea" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)" @keydown.native="handleKeyCode($event)">
            </quill-editor>
            <el-button type="primary" class="submit" @click="sendmessage()" round>发送</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import transparentheaders from "../components/transparentheaders.vue";
import {
  industryList,
  regionList,
  listPropertyUser,
  userPropertyList,
  listFriend,
  listMyFriendRecord,
  listFriendWaiting,
  addchatRecordServer,
  chatRecordServer,
  queryById,
  updateFriend,
  acceptFriend,
  rejectFriend,
  emojisList,
  grouplist,
  newgrouplist,
  addgroup,
  countFriendWaiting,
  chatRecordServercountall
} from "../api/api"
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径
const searchResults = []
const chatimgItems = [];
const emoItems = [];
const newgroupItems = [{}];
const chatItems = [

];
const friendItems = [];
const groupItems = [];
export default {

  // 显示字段超出相应长度后截取 可设置多个
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 8) + "...";
      }
      return value;
    },
    ellipsisnote(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 9) + "...";
      }
      return value;
    },
    ellipsisnew(value) {
      if (!value) return "";
      if (value.length > 6) {
        return value.slice(0, 6) + "...";
      }
      return value;
    },
  },

  components: {
    transparentheaders
  },
  data() {
    return {
      activeNames: ["1"],
      friendItems,
      searchvalue: "", //搜索框值
      textarea: "", //对话框发送的值
      note: "", //备注值
      chatItems,
      groupItems,
      notemodify: "",
      innerVisible: false,
      dialogFormVisible: false,
      form: {
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      circle: "",
      industry: "",
      region: "",
      propertyId: "",
      regionId: "",
      industryId: "",
      selectList1: [],
      selectList2: [],
      selectList3: [],
      formLabelWidth: "100px",
      groupvalue: "",
      newgroup: "", //新建分组的值
      findvalue: false, //是否开启搜索
      newgroupItems, //存放新的分组信息
      emoItems, //存放表情包
      chatimgItems, //存放发送消息的表情
      searchHistory: [], //存放搜索历史
      searchResults,
      newItems: [],
      completeItems: [],
      options: [],
      userid: "",
      imgUrl,
      youId: "",
      groupId: "",
      multipartFile1: {
        biz: "kefu"
      }, //文件上传参数
      multipartFile2: {
        biz: "file",
        'content-type': 'multipart/form-data'

      }, //文件上传参数
      chatId: "", //判断聊天对象
      chatpic: "", //聊天对象头像
      chatname: "",
      newnum: "",
      nums: "",
      propernum: [],
      chat: [],
      wsmsg: "",
      aboutfriend: "",
      showred: false,
      sign: true,
      save: [],
      startQueryTime: "",
      pageNo: 1,
      arr: [],
      editorOption: {
        modules: {
          toolbar: [

          ],
          keyboard: {
            bindings: {
              // 阻止回车键输入 br 标签
              noBreak: {
                key: 13,
                handler: function (e) {
                  return false;
                }
              }
            }
          }
        },

        placeholder: '请输入文字',

      },
      timer: null, //定时器
      websocket: null, //websocket
      click: false, //是否点击进去
      pageNo: 1,
      timer2: null, //定时器
      heartbeatTimer: null, // 心跳定时器
      isReconnect: true, //判断是否需要自动重连
    }
  },
  created() {

    this.chatId = this.$route.query.chatId;

    if (!sessionStorage.getItem("strDate")) {
      sessionStorage.setItem("strDate", this.currentTime());
    }

    if (!sessionStorage.getItem("friTime")) {
      sessionStorage.setItem("friTime", this.currentTime());
    }
    clearInterval(this.timer);
    this.groupItems = []
    this.chatItems = []

  },

  computed: {
    me() {
      return JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
    }
  },
  beforeDestroy() { //页面关闭时清除定时器  
    this.cleanUp();
    if (this.timer)
      clearInterval(this.timer);
  },
  mounted() {
    this.$forceUpdate();
    const value = this.$store.state.globalVariable;
    // console.log(value); // 输出全局变量的值
    this.userid = JSON.parse(
      sessionStorage.getItem("userinfo_Data")
    ).id

    window.addEventListener('beforeunload', this.cleanUp);
    userPropertyList({
      userId: this.userid,
    }).then(res => {
      this.propertyId = res.data.result[0].id;
      this.selectList1 = res.data.result;
      this.circle = res.data.result[0].id
      industryList({
        propertyId: this.propertyId,
      }).then(res => {
        this.selectList2 = res.data.result
      });
      regionList({
        propertyId: this.propertyId,
      }).then(res => {
        this.selectList3 = res.data.result
      });

    });
    this.openTimer()
    emojisList().then(res => {
      if (res.data.code == 200) {
        this.emoItems = res.data.result
      }
    });
    this.createWebSocket();
    window.onbeforeunload = function () {
      this.websocket.close();
    }
    // this.load();
    this.getfriendUser();
    this.shownewfriend();
    this.getqueryById();

    if (this.$route.query.chatId) {

      this.getchatRecord();
    }
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.cleanUp);
  },
  methods: {
    createWebSocket() {
      var userId = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
      if ('WebSocket' in window) {
        // websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketRingStar/" + userId);
        // this.websocket = new WebSocket("ws://q66uqq.natappfree.cc/jeecg-boot/websocketSingle/" + userId);
        this.websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketSingle/" + userId);
      } else {
        alert('当前浏览器 Not support websocket')
      }
      let self = this
      //连接发生错误的回调方法
      this.websocket.onerror = function () {
        console.log("WebSocket连接发生错误");
      };
      let isConnected = false;
      //连接发生错误的回调方法

      //连接成功建立的回调方法
      if (!isConnected) {
        this.websocket.onopen = function connectWebSocket() {
          console.log("WebSocket连接成功");
          isConnected = true;
          self.heartbeatTimer = setInterval(function () {
            self.websocket.send("heartbeat");
          }, 30 * 1000);
        }
        this.websocket.onclose = function (e) {
          console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
          self.createWebSocket();
        }
      }
      //接收到消息的回调方法
      this.websocket.onmessage = (event) => {

        const data = JSON.parse(event.data);
        // data.fromUserId = this.chatId
        data.toUserId = this.userid
        data.mePic = this.chatpic
        if (this.click && data.fromUserId == this.chatId) {
          this.chatItems.push(data);
          console.log("发送成功")
          this.handleScrollBottom()
        }

        // this.navItems[2].isred = false;
        this.$store.commit('updateGlobalVariable', 1);

        //  this.playAudio()
        let buttonAudio = document.getElementById('my_audio');
        console.log("声音正常")
        var audio = require('../assets/audios/y1479.mp3')
        buttonAudio.setAttribute('src', audio)
        buttonAudio.play().catch((err) => {
          console.log(err)
        })

      }

    },
    cleanUp() {
      this.websocket.close();
    },
    // playsound() { 
    //   console.log("111")
    //   this.$refs.audio.src = require("../assets/audios/y1479.mp3");
    //   this.$refs.audio.currentTime = 0; //从头开始播放提示音
    //   this.$refs.audio.play(); //播放
    // },
    openTimer() {
      this.timer2 = setInterval(() => {

          listPropertyUser({
            userId: this.userid,
            propertyId: this.propertyId,
            industryId: this.industryId,
            bigRegionId: this.regionId,
            keyword: this.searchvalue,
            pageNo: this.pageNo,
            pageSize: 100,

          }).then(res => {
            this.pageNo = this.pageNo + 1
            // console.log(this.pageNo)
            // console.log(res.data.result.records.length)
            if (res.data.result.records.length)
              this.groupItems.push(...res.data.result.records);

          });

        },
        1000)
      this.timer = setInterval(() => {

          // listPropertyUser({
          //   userId: this.userid,
          //   propertyId: this.propertyId,
          //   industryId: this.industryId,
          //   bigRegionId: this.regionId,
          //   keyword: this.searchvalue,
          //   pageNo: this.pageNo,
          //   pageSize: 100,

          // }).then(res => {
          //   this.pageNo = this.pageNo + 1
          //   // console.log(this.pageNo)
          //   // console.log(res.data.result.records.length)
          //   if (res.data.result.records.length)
          //     this.groupItems.push(...res.data.result.records);

          // });
          countFriendWaiting({
            userId: this.userid
          }).then(res => {
            if (res.data.code == 200) {
              this.newnum = res.data.result
            }
          });

          chatRecordServercountall({

            me: this.userid,
            startQueryTime: (sessionStorage.getItem("friTime")),
          }).then(res => {
            if (res.data.code == 200) {
              if (res.data.result.length) {
                this.aboutfriend = res.data.result.length

              }
              this.nums = res.data.result
              if (this.nums)
                this.changenums();
              this.getfriendUser();
            }
          });

        },
        1000)

    },
    userNum(id) {

      let a = this.nums.filter(item => {
        return item.f0 == id
      })

      if (a.length) {

        return a[0].f1
      }
    },
    changenums() {
      if (!this.nums || !this.nums.length) {
        return
      }
      const mergedArray = this.groupItems.map(item => {
        const matchingObj = this.nums.find(obj => obj.f0 === item.id);
        return {
          ...item,
          ...matchingObj
        };
      });

      this.propernum = mergedArray;

      // let arr = this.groupItems.map((item, i) => {

      //   return {
      //     id: item.id,
      //     use: this.userNum(item.id)
      //   }
      // })
      // this.propernum = arr
      // console.log(this.propernum)
    },
    onEditorFocus() {

    },
    onEditorBlur() {

    },
    onEditorChange() {

    },
    getqueryById() {
      if (this.chatId) {
        queryById({
          id: this.chatId
        }).then(res => {
          if (res.data.code == 200) {
            this.chatname = res.data.result.mininame
            this.chatpic = res.data.result.personPic
          }
        });

      } else {}
    },
    openFile(url) {
      window.open(url)
    },
    handleScroll(e) {

      let el = e.target
      //判断是否到达div容器底部

      if (el.scrollTop <= 0) {
        //控制页数
        this.pageNo = this.pageNo + 1
        //调用后台接口
        this.getpage()

      }
    },
    updatepicture1(res) {
      let data = {
        fromUserId: this.userid,
        toUserId: this.chatId,
        content: res.message,
        contentType: 2,
      }

      addchatRecordServer(data).then(res => {
        if (res.data.code == 200) {

        }

      });
      data.createTime = this.currentTime()
      data.mePic = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).personPic
      data.mininame = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).mininame
      this.chatItems.push(data);
      this.handleScrollBottom()
    },
    updatepicture2(res) {
      let data = {
        fromUserId: this.userid,
        toUserId: this.chatId,
        content: res.message,
        contentType: 3,

      }
      addchatRecordServer(data).then(res => {
        if (res.data.code == 200) {

        }

      });
      data.createTime = this.currentTime()
      data.mePic = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).personPic
      data.mininame = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).mininame
      this.chatItems.push(data);
      this.handleScrollBottom()
    },
    handleScrollBottom() {
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv;
        scrollElem.scrollTo({
          top: scrollElem.scrollHeight,
          behavior: "smooth"
        });
      });
    },
    sendmessage() {
      let data = {

        content: this.textarea.match(/\<img.*?\>/) ? this.textarea : this.textarea.replace(/ /g, '&nbsp;'),
        contentType: 1,
        fromUserId: this.userid,
        toUserId: this.chatId,
      }
      addchatRecordServer(data).then(res => {
        if (res.data.code == 200) {

        }

      });
      data.createTime = this.currentTime()
      data.mePic = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).personPic
      data.mininame = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).mininame
      this.chatItems.push(data);
      this.handleScrollBottom()
      this.textarea = ""
    },
    changepropertyId(e) {
      this.industry = ""
      this.region = ""
      this.industryId = ""
      this.regionId = ""
      this.propertyId = e;
      industryList({
        propertyId: this.propertyId,
      }).then(res => {
        this.selectList2 = res.data.result
      });
      regionList({
        propertyId: this.propertyId,
      }).then(res => {
        this.selectList3 = res.data.result
      });
      this.getlistPropertyUser();
    },
    changeindustryId(e) {
      this.industryId = e;
      this.getlistPropertyUser();
    },
    changeregionId(e) {
      this.regionId = e;
      this.getlistPropertyUser();

    },
    //     playsound() {
    //       console.log("111")
    //       this.$refs.audio.src = require("../assets/audios/y1479.mp3");
    // this.$refs.audio.currentTime = 0; //从头开始播放提示音
    // this.$refs.audio.play(); //播放
    //     },
    getlistPropertyUser() {
      let time = []
      listPropertyUser({
        userId: this.userid,
        propertyId: this.propertyId,
        industryId: this.industryId,
        bigRegionId: this.regionId,
        keyword: this.searchvalue,
        pageNo: 1,
        pageSize: 100,

      }).then(res => {
        this.groupItems = res.data.result.records

        this.groupItems.forEach((item, i) => {
          if (!sessionStorage.getItem("friendTime1")) {
            time.push({
              id: item.id,
              time: this.currentTime(),
            })

          } else {
            time.push({
              id: item.id,
              time: this.currentTime(),
            })
          }
          sessionStorage.setItem("friendTime1", JSON.stringify(time))
        })

      });
      return true
    },
    getFriendgroup() {
      listFriend({
        userId: this.userid,
        propertyId: JSON.parse(sessionStorage.getItem("indexTime"))[0].id,
        industryId: this.industryId,
        bigRegionId: this.regionId,
        keyword: this.searchvalue,
        pageNo: 1,
        pageSize: 40,

      }).then(res => {
        // let arr = res.data.result
        // for (var group in arr) {
        //     this.groupname.push({
        //         index: group
        //     })
        // }
        // console.log(this.groupname)
      });
    },
    getfriendUser() {
      this.getFriendgroup();
      listFriend({
        userId: this.userid,
        propertyId: this.propertyId,
        industryId: this.industryId,
        bigRegionId: this.regionId,
        keyword: this.searchvalue,
        pageNo: 1,
        pageSize: 40,

      }).then(res => {
        var obj = res.data.result;

        this.friendItems = obj
        const friendIds = [];
        Object.keys(this.friendItems).forEach(key => {
          obj[key].forEach(item => {
            friendIds.push(item.friendsId);
          });
        });

        const f0Values = [];

        this.nums.forEach(item => {
          f0Values.push(item.f0);
        });

        const hasCommonValue = friendIds.some(id => f0Values.includes(id));

        this.showred = hasCommonValue // 输出：true

      });

    },
    cleargroup() {
      this.newgroup = "";
    },

    newgrouplist() {
      if (this.newgroup) {
        let data = {
          appuserId: this.userid,
          name: this.newgroup,
        }
        addgroup(data).then(res => {
          if (res.data.code == 200) {
            grouplist({
              userId: this.userid,
            }).then(res => {
              this.options = res.data.result;

            });

          }

        });

      } else {
        this.msg = "分组名不能为空"
        this.opennotice()
      }
      this.getfriendUser();
    },
    opennotice() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {
        // if (this.msg === "注册成功") {
        //   this.$router.push({
        //     path: "/"
        //   });
        // }
      });
    },
    open() {
      this.$alert("发送内容不能为空", "提示", {
        confirmButtonText: "确定",
        callback: action => {}
      });
    },
    handleKeyCode(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        e.cancelBubble = true; //ie阻止冒泡行为
        e.stopPropagation(); //Firefox阻止冒泡行为
        e.preventDefault(); //取消事件的默认动作*换行
        //以下处理发送消息代码
        this.sendmessage();
      }

    },

    setKeyWord1(str) {
      if (this.findvalue === true) {
        const reg = new RegExp(this.searchvalue, "g");

        return str.replace(
          reg,
          `<span style="color: rgb(55,128,237);">${this.searchvalue}</span>`
        );
      } else {
        return str;
      }
    },
    setKeyWord2(str) {
      if (this.findvalue === true) {
        const reg = new RegExp(this.searchvalue, "g");
        return str.replace(
          reg,
          `<span style="color: rgb(195,229,255);">${this.searchvalue}</span>`
        );
      } else {
        return str;
      }
    },
    reset() {
      this.findvalue = false;
    },

    clearTextarea() {
      this.textarea = "";
    },
    showexpression() {
      var emo = document.querySelector(".emopackage");

      if ((emo.style.display === "block")) {
        emo.style.display = "none";
      } else {
        emo.style.display = "block";
      }

    },
    sendimg(e) {
      let data = {
        fromUserId: this.userid,
        toUserId: this.chatId,
        content: e,
        contentType: 0,
      }
      var res

      res = imgUrl + e
      console.log(res)
      if (res) {
        // 获取光标所在位置
        let quill = this.$refs.myQuillEditor.quill;
        quill.focus()
        let length = quill.getSelection().index
        console.log(length)
        // 插入图片，res为服务器返回的图片链接地址
        quill.insertEmbed(length, "image", res);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        // 提示信息，需引入Message
        this.$message.error("图片插入失败！");
      }
      // addchatRecordServer(data).then(res => {
      //   if (res.data.code == 200) {

      //   }
      // });
    },
    handlePreview(file) {

    },
    pushmycenter() {
      this.$router.push({
        path: "/mycenter"
      });
    },
    getchatRecord() {
      this.chatItems = []
      this.click = true;
      // console.log(this.chatItems)
      this.$store.commit('updateGlobalVariable', 0);
      this.propernum = ""
      this.aboutfriend = ""
      this.showred = ""
      this.pageNo = 1
      sessionStorage.setItem("friTime", this.currentTime());
      chatRecordServer({
        me: this.userid,
        you: this.chatId,
        pageNo: this.pageNo,
        pageSize: 7,
      }).then(res => {
        if (res.data.code == 200) {

          this.chatItems = res.data.result.records.reverse();
          this.handleScrollBottom()
        }

      });
      this.timer = setInterval(() => {

          // if (1) {
          //   chatRecordServer({
          //     me: this.userid,
          //     you: this.chatId,
          //     startQueryTime: this.startQueryTime,
          //     pageNo: 1,
          //     pageSize: 1000,
          //   }).then(res => {
          //     if (res.data.code == 200) {
          //       // console.log(res.data.result.records)
          //       if (!res.data.result.records.length) {

          //         return
          //       }
          //       this.startQueryTime = res.data.result.records.length > 0 ? res.data.result.records[0].createTime : ""
          //       let k = res.data.result.records.reverse();

          //       var newList = this.chatItems.concat(k)
          //       // console.log(newList)
          //       this.chatItems = newList
          //       this.handleScrollBottom()
          //       return true;

          //     }

          //   });
          // }
          // this.handleScrollBottom();

        },
        2000)

      queryById({
        id: this.chatId
      }).then(res => {
        if (res.data.code == 200) {
          this.chatname = res.data.result.mininame
          this.handleScrollBottom()
        }
      });
    },
    getpage() {
      chatRecordServer({
        me: this.userid,
        you: this.chatId,
        pageNo: this.pageNo,
        pageSize: 7,
      }).then(res => {
        if (res.data.code == 200) {

          this.chatItems = res.data.result.records.reverse().concat(this.chatItems)
          this.pageNo = this.pageNo + 1
        }

      });
    },
    getchatRecord_click(e, f) {
      this.chatpic = f
      this.click = true;
      this.chatItems = []
      clearInterval(this.timer2)
      this.pageNo = 1
      // console.log(this.chatItems)
      this.$store.commit('updateGlobalVariable', 0);
      this.propernum = ""
      this.aboutfriend = ""
      this.chatId = e
      this.showred = ""
      sessionStorage.setItem("friTime", this.currentTime());
      chatRecordServer({
        me: this.userid,
        you: this.chatId,
        pageNo: this.pageNo,
        pageSize: 7,
      }).then(res => {
        if (res.data.code == 200) {

          this.chatItems = res.data.result.records.reverse();
          this.handleScrollBottom()
        }

      });

      // this.timer = setInterval(() => {

      //     if (1) {
      //       chatRecordServer({
      //         me: this.userid,
      //         you: this.chatId,
      //         startQueryTime: this.startQueryTime,
      //         pageNo: 1,
      //         pageSize: 1000,
      //       }).then(res => {
      //         if (res.data.code == 200) {
      //           // console.log(res.data.result.records)
      //           if (!res.data.result.records.length) {

      //             return
      //           }
      //           this.startQueryTime = res.data.result.records.length > 0 ? res.data.result.records[0].createTime : ""
      //           let k = res.data.result.records.reverse();

      //           var newList = this.chatItems.concat(k)
      //           // console.log(newList)
      //           this.chatItems = newList
      //           this.handleScrollBottom()
      //           return true;

      //         }

      //       });
      //     }
      //     this.handleScrollBottom();

      //   },
      //   1000)

      queryById({
        id: this.chatId
      }).then(res => {
        if (res.data.code == 200) {
          this.chatname = res.data.result.mininame
          this.handleScrollBottom()
          console.log("111")
        }
      });

    },
    agreefriend(e) {
      let data = {
        id: e
      }
      acceptFriend(data).then(res => {
        if (res.data.code == 200) {
          this.shownewfriend();
        }
      });
      this.newnums = "";
    },
    rejectfriend(e) {
      let data = {
        id: e
      }
      rejectFriend(data).then(res => {
        if (res.data.code == 200) {
          this.shownewfriend();
        }
      });
      this.newnums = "";
    },
    shownewfriend() {
      listFriendWaiting({
        userId: this.userid,
        propertyId: JSON.parse(sessionStorage.getItem("indexTime"))[0].id,
        industryId: this.industryId,
        bigRegionId: this.regionId,
        keyword: this.searchvalue,
        pageNo: 1,
        pageSize: 40,

      }).then(res => {
        this.newItems = res.data.result

      });
      listMyFriendRecord({
        userId: this.userid,
        pageNo: 1,
        pageSize: 20

      }).then(res => {
        if (res.data.code == 200)
          this.completeItems = res.data.result.records

      });
    },
    submitgroup() {

      let data = {
        groupId: this.groupId,
        id: this.youId,
        memo: this.note,
      }
      updateFriend(data).then(res => {
        if (res.data.code == 200) {}

      });
      this.dialogFormVisible = false;

      this.getfriendUser();
      location.reload();

    },
    opendialog(e, f, h) {
      // console.log(h)
      this.note = f
      this.youId = e
      this.groupvalue = h
      this.groupId = h
      this.dialogFormVisible = true;
      grouplist({
        userId: this.userid,
      }).then(res => {

        this.options = res.data.result

      });

    },
    newgrouplist() {

      if (this.newgroup) {
        let data = {
          appuserId: this.userid,
          name: this.newgroup,
        }
        addgroup(data).then(res => {
          if (res.data.code == 200) {
            grouplist({
              userId: this.userid,
            }).then(res => {
              this.options = res.data.result

            });
          }

        });
        this.innerVisible = false;

      } else {
        this.msg = "分组名不能为空"
        this.opennotice()
      }

    },
    loadAll() {
      this.getlistPropertyUser();
    },
    changegroup(e) {
      this.groupId = e
    },
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      var strDate =
        year +
        "-" +
        dateArr[0] +
        "-" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4];
      //此处可以拿外部的变量接收  strDate:2022-05-01 13:25:30
      //this.date = strDate;
      return strDate;
    },

  }
};
</script>

<style lang="scss" scoped>
.friend {
  margin-top: 70px;
  display: flex;

  height: 90vh;
}

.friend-left {
  background: white;
  flex-grow: 0.23;
  margin-right: 10px;
  font-size: 26px;
  font-family: "SourceHanSansCN";
  color: rgb(51, 51, 51);
  line-height: 4.5;
  flex-wrap: nowrap;
  padding: 30px 15px 15px 15px;
  flex: 0 0 320px;
  overflow: auto;
}

#content {
  margin-right: 15px;
  margin-bottom: -20px;
  padding-left: 80px;
}

#content_new {
  margin-bottom: 15px;
  margin-top: 10px;
  padding-left: 43px;
  line-height: 20px;
}

#content_new_no {
  margin-bottom: 15px;
  margin-top: 5px;
  padding-left: 100px;
  line-height: 20px;
}

>>>.el-collapse-item__header {
  font-size: 16px;
  font-family: "SourceHanSansCN";
  color: rgb(51, 51, 51);
  line-height: 4.5;
  text-align: justifyLeft;
}

>>>.el-collapse-item__arrow {
  content: url(../assets/images/arrow_blue_right.png);
}

>>>.collapse-title-down .el-collapse-item__arrow {
  margin-left: 20px;
  margin-bottom: -20px;
}

.friend-left div {
  font-size: 14px;
  font-family: "SourceHanSansCN";
  color: rgb(85, 85, 85);
  line-height: 5.143;
  margin-top: -10px;
  margin-bottom: 20px;
}

.friendlist div {
  font-size: 14px;
  font-family: "SourceHanSansCN";
  color: rgb(85, 85, 85);
  line-height: 5.143;
  margin-bottom: 0px !important;
  // margin-top: -5px  !important;
}

.el-collapese {
  padding: 20px;
}

>>>.collapse-title {
  display: relative;
  flex: 1 0 90%;
  order: 1;
  margin-left: 5px;
  // margin-bottom: 4px;
}

>>>.collapse-title1 {
  display: relative;
  flex: 1 0 90%;
  order: 1;
  margin-left: 5px;
  // margin-bottom: 4px;
}

>>>.collapse-title-down {
  flex: 1 0 90%;
  order: 1;
  margin-left: 5px;
  // margin-bottom: 4px;
}

.friend-right {
  background: white;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  border-bottom: solid 1px rgb(237, 245, 255);
  padding: 25px;
  justify-content: space-between;
}

.content {
  height: 600px;
  border-bottom: solid 1px rgb(237, 245, 255);
  overflow: scroll;
  overflow-x: hidden;
  padding: 20px;
}

.bottom {
  height: 360px;
}

>>>.quill-editor {
  height: 220px;
  overflow: hidden;

}

>>>.el-collapse-item__wrap {
  border: none;
}

>>>.el-collapse-item__header {
  border: none;
  margin-left: 30px;
}

>>>.el-collapse,
>>>.el-collapse-item__content {
  border: none;
  padding-bottom: 0px;
}

.background {
  padding: 20px;
  background: rgb(234, 242, 250);
  // height: 976px;
  height: 100vh;
  // width: 100%;
}

.white {
  background: white;
}

.headicon {
  margin-right: 10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}

.find {
  // border-width: 1px;
  border-color: rgb(71, 145, 255);

  height: 10px;
  margin-top: 1px;
}

>>>.find .el-input__inner {
  border: solid 1px;
  border-radius: 40px;
  height: 35px;
  padding-left: 40px;
}

>>>.el-input__inner {
  // border: solid 1px;
  border-radius: 10px;
  // height: 35px;
  padding: 10px 10px 10px 10px;
}

.search {
  height: 34px;
  width: 85px;
  background-color: rgb(10, 108, 255);
  font-size: 16px;
  font-family: "HarmonyOS_Sans_SC";
  color: rgb(255, 255, 255);
  line-height: 3px;
  letter-spacing: 10px;
  border-radius: 20px;
}

.submit {
  height: 40px;
  width: 100px;
  background-color: rgb(10, 108, 255);
  font-size: 16px;
  font-family: "HarmonyOS_Sans_SC";
  color: rgb(255, 255, 255);
  line-height: 3px;

  margin-left: 776px;
}

.findimg {
  margin-top: 9px;
  margin-left: 10px;
}

.dialog_icon {
  margin-right: 10px;
  margin-left: 4px;
  cursor: pointer;
}

.dialog_icon_total {
  display: flex;
  margin-left: 48px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.textarea {
  margin-left: 48px;
  width: 823px;

  border-width: 1px;
  border-color: rgb(204, 227, 255);
  border-style: solid;
  border-radius: 10px;
}

>>>.bottom .el-textarea__inner {
  margin-left: 40px;
  width: 830px !important;
  height: 70px !important;
  margin-top: -10px;
  border-width: 1px;
  border-color: rgb(204, 227, 255);
  border-style: solid;
  border-radius: 10px;
  margin-bottom: 10px;
}

>>>.el-textarea__inner {
  resize: none;
  height: 60px;
}

// ::-webkit-scrollbar {
//   display: none;
//   /* Chrome Safari */
// }

.chatcontent {
  padding: 20px;
}

.chat-user-1 {
  display: flex;

  margin-top: 5px;
  font-size: 14px;
  font-family: "Adobe Heiti Std";
  color: rgb(51, 51, 51);
}

.chat-user-2 {
  margin-top: 5px;
  display: flex;
  flex-direction: row-reverse;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  color: rgb(255, 255, 255);
  line-height: 1.714;
  text-align: justifyright;
}

.chat-user-1-text {
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
  max-width: 550px;
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  word-wrap: break-word;
  word-break: break-all;
  padding: 10px 22px;
}

.chat-user-2-text {
  border-radius: 10px;
  background-color: rgb(71, 145, 255);
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 550px;
  padding: 10px 22px;
  word-wrap: break-word;
  word-break: break-all;
  float: right;
}

.chat-user-1-headicon {
  margin-right: 15px;
  margin-left: 10px;
  align-self: flex-start;
  word-wrap: break-word; //英文换行
  height: 50px;
  width: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.chat-user-2-headicon {
  margin-left: 15px;
  margin-right: 10px;
  align-self: flex-start;
  word-wrap: break-word; //英文换行
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}

.notes {
  color: #999999 !important;
  line-height: 35px !important;
  margin-left: 42px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}

.agreebutton {
  // margin-right: -10px;
  width: 50px;
  line-height: 3px;
  text-align: left;
  padding: 12px 10px;
}

.refusebutton {
  width: 50px;
  line-height: 3px;
  text-align: left;
  padding: 12px 10px;
}

>>>.el-button+.el-button {
  margin: 0%;
}

>>>.el-icon-arrow-up:before {
  content: url(../assets/images/arrow.png);
}

.verify {
  color: red !important;

  float: right;
  margin-right: 40px;
  margin-top: 3px;
}

.el-icon-edit {
  margin-left: 5px;
  cursor: pointer;
}

>>>.el-form-item__label {
  margin-top: 15px;
}

.el-input {
  width: 215px;
}

.newgroup {
  margin-left: 10px;
}

.nameclick {
  cursor: pointer;
}

.collapse_down {
  margin-left: 20px;
}

>>>.el-form-item__label {
  line-height: 5px;
}

.emoimg {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 15px;
}

.emopackage {
  position: absolute;
  display: flex;
  word-wrap: break-word;
  width: 340px;
  max-height: 420px;
  padding: 5px;
  overflow: hidden;
  transform: translateY(-90px);
  margin-left: 50px;
  display: none;
  box-shadow: 0 0 7px 7px rgb(237, 244, 253);
  background-color: white;
}

.dialogimg {
  width: 60px;
  height: 60px;
}

.aboutdot {
  width: 8px;
  height: 8px;
  transform: translateY(-25px) translateX(6px);

}

>>>.el-upload-list__item {
  display: none;
}

>>>.el-upload-list__item-name {
  transition: none !important;
  display: none;
}

>>>.el-upload-list__item .el-icon-upload-success {
  display: none;
}

>>>.collapse-title .el-badge__content {
  // height: auto;
  transform: translateY(5px) translateX(-6px);
}

>>>.select_p .el-input__inner {
  width: 150px;
}

>>>.select_industry .el-input__inner {
  width: 140px;
  margin-right: 5px;
}

>>>.select_region .el-input__inner {
  width: 140px;
  margin-right: 5px;
}

.select {
  margin-right: 5px;
}

.chatnametitle {
  display: fixed;
  text-align: center;
  color: white;
  font-size: 15px !important;
  background-color: rgb(71, 145, 255);

  padding: 5px;
}

>>>.collapse-title .el-badge__content,
.el-progress.is-exception .el-progress-bar__inner {
  background-color: #F56C6C;
}

.numcare {
  position: absolute;
  left: 20px;
  top: -10px;
  border-radius: 50%;
  line-height: 20px;
  background-color: #f00;
  font-size: 15px;
  text-align: center;
  width: 20px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  font-style: normal;
}

.time_me {
  color: #aaa;
  font-size: 12px !important;
  margin-bottom: 10px;
}

.time_me_up {
  display: flex;
  flex-direction: row-reverse;
}

.time {
  color: #aaa;
  font-size: 12px !important;
  margin-bottom: 10px;
}

.rel {
  position: relative;
}

.itemdot {
  margin-bottom: -5px;
}

>>>.item .el-badge__content {
  height: auto;
}

>>>.el-badge__content.is-fixed.is-dot {
  right: 1px;
  top: 5px;
}

>>>.ql-toolbar.ql-snow {
  border: none;
  height: 0px !important;

  border-bottom: 1px solid #ccc;
}

.ql-snow .ql-editor img {
  width: 20px;
  height: 20px;
}

.ql-container.ql-snow {
  border: 1px solid #2c97e9;

  height: 150px;
  z-index: 9999;
}
</style><style lang="scss">
.down-popover[x-placement^="bottom"] {
  margin-top: 32px;
}

.option-item {
  line-height: 28px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    cursor: pointer;
    background: #f5f7fa;
  }
}

.image-container img {
  width: 20px;
  height: 20px;
}

.nosearch {
  color: grey;
  text-align: center;
  font-size: 12px;
}

.countnum {
  float: right;
  margin-right: 30px;
  color: red;
}

.flex_2 .dialogimg {
  float: right;
  margin-top: 5px;
}

.flex_2 .chat-user-2-text {
  float: right;
  margin-top: 5px;
}

.ql-snow .ql-editor img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/friend.vue